import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { pagination, THRESHOLD_DEFAULT } from 'utils/constants';

const initialState: UserState = {
    user: undefined,
    staff: {
        data: [],
        pagination,
    },
    threshold: THRESHOLD_DEFAULT,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<IUser | undefined>) => {
            state.user = action.payload;
        },

        removeUser: (state) => {
            state.user = undefined;
        },

        setUserOptions: (state, action: PayloadAction<Dropdown<DropdownItem>>) => {
            state.staff = action.payload;
        },
        setThresholds: (state, action: PayloadAction<IThreshold | IThresholdDefault>) => {
            state.threshold = action.payload;
        },
    },
});

export const { setUser, removeUser, setUserOptions, setThresholds } = userSlice.actions;

export default userSlice.reducer;
